import React, { useState } from "react";
import { Modal, Card } from "antd";

type ActionModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  handleOk: () => Promise<void> | void;
  steps: string;
  children: React.ReactNode;
  confirmLoading?: boolean;
  resetForm: () => void;
  width?: number;
};

export const ActionModal: React.FC<ActionModalProps> = ({
  isOpen,
  onClose,
  title,
  handleOk,
  steps,
  children,
  confirmLoading,
  resetForm,
  width,
}) => {
  const resetState = () => {
    resetForm();
  };
  const childrenArray = React.Children.toArray(children);

  return (
    <Modal
      title={<span style={{ color: "white" }}>{title}</span>}
      open={isOpen}
      onOk={handleOk}
      onCancel={resetState}
      okText={steps}
      confirmLoading={confirmLoading}
      width={width ? width : 600}
      bodyStyle={{ minHeight: 200, padding: 8, paddingBottom: 8, paddingLeft: 0, paddingRight: 0 }}
    >
      <Card loading={confirmLoading}> {childrenArray}</Card>
    </Modal>
  );
};
